import { render, staticRenderFns } from "./InboxViewItem.vue?vue&type=template&id=4952856c&lang=pug"
import script from "./InboxViewItem.vue?vue&type=script&lang=js"
export * from "./InboxViewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports